($ => {
  function handleProductListScroll() {
    if ($("header .ajaxsearchpro.vertical").length) {
      const productListContainer = document.querySelector(
        ".ajaxsearchpro.vertical"
      );
      // Toggle product list class when scroll hit bottom of container
      const toggleProductListContainerClass = productsList => {
        productsList.addEventListener("scroll", function() {
          if (
            productsList.scrollTop ===
            productsList.scrollHeight - productsList.offsetHeight
          ) {
            productListContainer.classList.add("scrolled");
          } else {
            productListContainer.classList.remove("scrolled");
          }
        });
      };

      // Reload page when orientation changes - fix for Ajax Search Pro bug with product list height calculation on load
      const checkScreenOrientation = () => {
        window.onorientationchange = function() {
          let orientation = window.orientation;

          switch (orientation) {
            // Refresh only while back from horiontal to vertical
            case 0:
              // case 90:
              // case -90:
              window.location.reload();
              break;
          }
        };
      };

      // Observe if product list exists (is open)
      const mo = new MutationObserver(() => {
        if (
          document.querySelector(
            ".ajaxsearchpro.vertical .asp_simplebar-content-wrapper"
          )
        ) {
          let productsList = document.querySelector(
            ".ajaxsearchpro.vertical .asp_simplebar-content-wrapper"
          );

          toggleProductListContainerClass(productsList);
          checkScreenOrientation();
        }
      });

      mo.observe(productListContainer, { subtree: true, childList: true });
    }
  }

  $(document).ready(() => {
    handleProductListScroll();
  });
})(jQuery);
